/** @format */

export enum RewardDeliveryMethodEnum {
  Mail = 1,
  Email = 2,
}
